// HKDSE 2022 Paper 1 Knowledge Graph Samples - Combined
// Merged from hkdse2022Samples.js and additional parts

import { hkdse2022Samples } from './hkdse2022Samples.js';
import { hkdse2022Samples_part2 } from './hkdse2022Samples_part2.js';
import { hkdse2022Samples_part3 } from './hkdse2022Samples_part3.js';
import { hkdse2022Samples_part4 } from './hkdse2022Samples_part4.js';

export const hkdse2022Samples_combined = {
  ...hkdse2022Samples,
  ...hkdse2022Samples_part2,
  ...hkdse2022Samples_part3,
  ...hkdse2022Samples_part4
};

// Export individual parts for backward compatibility
export { 
  hkdse2022Samples, 
  hkdse2022Samples_part2, 
  hkdse2022Samples_part3, 
  hkdse2022Samples_part4 
}; 